import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  const fallbackImage = "https://placehold.co/1200x800/222222/CCCCCC?text=Segway+Capital";
  
  return (
    <section className="pt-8 pb-10 md:pt-16 md:pb-20 bg-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-secondary/5 rounded-bl-full"></div>
        <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-secondary/5 rounded-tr-full"></div>
      </div>
      
      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content column */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            {/* <h2 className="text-4xl font-heading font-bold text-primary mb-6">About Segway Capital</h2> */}
            <p className="text-xl text-gray-600 mb-6 font-body">
              <span className="font-semibold">Segway Capital Management</span> offers a personal and proactive approach to managing your wealth. We take the time to get to know you and understand your ambitions to create unique solutions for every stage of your life's journey.
            </p>
            
            <div className="mb-8 border-l-4 border-secondary pl-6 py-2">
              <p className="text-lg italic text-gray-600 font-heading">
                "Our mission is to build lasting relationships through trust, integrity, and exceptional financial expertise."
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <div className="flex items-center">
                <div className="text-3xl font-heading font-bold text-secondary mr-2">15+</div>
                <div className="text-gray-600">Years of Excellence</div>
              </div>
              <div className="flex items-center">
                <div className="text-3xl font-heading font-bold text-secondary mr-2">$5B+</div>
                <div className="text-gray-600">Assets Managed</div>
              </div>
              <div className="flex items-center">
                <div className="text-3xl font-heading font-bold text-secondary mr-2">1200+</div>
                <div className="text-gray-600">Satisfied Clients</div>
              </div>
            </div>
            
            {/* <Link 
              to="/about-us" 
              className="btn btn-primary"
            >
              Learn More About Us
            </Link> */}
          </motion.div>
          
          {/* Image column */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="rounded-xl overflow-hidden shadow-custom"
          >
            <img 
              src="/assets/business-colleagues-banner-concept-with-copy-space.jpg"
              alt="Segway Capital Team" 
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = fallbackImage;
              }}
              className="w-full h-full object-cover"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 